import { Button, Stack, Typography } from '@mui/material';
import { usePrivy } from '@privy-io/react-auth';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNotification } from '../../hooks/useNotification';

const Login: React.FC = () => {
  const location = useLocation();
  const { login } = usePrivy();
  useNotification(true);

  useEffect(() => {
    sessionStorage.setItem('beforeLogin', location.state?.from?.pathname);
  }, [location]);

  return (
    <Stack
      height={'100vh'}
      padding={'auto'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Stack>
        <Typography>Login to proceed</Typography>
        <Button onClick={() => login()}>Login</Button>
      </Stack>
    </Stack>
  );
};

export default Login;
